import config from 'root/common/config/config';
import { addDomain } from './utils';

const goldCardUrls = {
    getGoldCardInfo: '/vip-member/vip/coupon/v1_0/listRechargeCoupons',
    createGoldCardOrder: '/vip-member/vip/order/v1_0/orderCreate',
    queryGoldCardPay: '/vip-member/vip/order/v1_0/payQuery',
};

const alipayIdentityVerify = {
    alipayIdentityVerify: `/recharge/identity/v1/identityVerify`,
};

const getOrderPayInfo = `${config.privilegeApiDomain}/system/query-order`; //查询订单状态
export default {
    ...addDomain(goldCardUrls, config.vipMemberDomain),
    ...addDomain(alipayIdentityVerify, config.privilegeApiDomain),
    getOrderPayInfo,
};
